<template>
  <div class="text-center">
    <etapa-dados-navio
      :descricao="descricao"
      :data_inicio="data_inicio"
      :data_fim="data_fim"
      @set-descricao="descricao = $event"
      @set-data-inicio="data_inicio = $event"
      @set-data-fim="data_fim = $event"
    />

    <v-row class="pa-5 pt-0">
      <v-spacer />
      <buttons-cadastro @close="close" @save="save" />
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import EtapaDadosNavio from './Etapas/EtapaDadosNavio.vue'
import ButtonsCadastro from '../../ButtonsCadastro/ButtonsCadastro.vue'

export default {
  name: 'FormAdicionarNavio',
  components: {
    EtapaDadosNavio,
    ButtonsCadastro,
  },
  props: {
    navioEdicao: {
      type: Object,
      default: () => null,
    },
  },
  data() {
    return {
      descricao: '',
      data_inicio: '',
      data_fim: '',
    }
  },
  computed: {
    ...mapState('auth', ['empresaAtual']),

    isEdit() {
      return !!(
        this.navioEdicao &&
        (this.navioEdicao.id || this.navioEdicao.public_id)
      )
    },
  },
  methods: {
    ...mapActions('patio', ['addNavio', 'editarNavio']),
    ...mapActions('template', ['successMessage', 'errorMessage']),

    close() {
      this.$emit('finished')
    },

    async save() {
      if (!this.empresaAtual || this.descricao === '') return
      const payload = {
        proprietario: this.empresaAtual.public_id,
        descricao: this.descricao,
        data_inicio: this.data_inicio,
        data_fim: this.data_fim,
      }

      try {
        if (this.isEdit) {
          const payloadNavioEditado = { id: this.navioEdicao?.id, ...payload }
          await this.editarNavio(payloadNavioEditado)
          this.successMessage('Navio editado com sucesso!')
        } else {
          await this.addNavio(payload)
          this.successMessage('Navio cadastrado com sucesso!')
        }

        this.$emit('finished')
      } catch (error) {
        this.errorMessage('Erro ao salvar navio.')
        console.error('Erro ao salvar navio:', error)
      }
    },
  },

  created() {
    if (this.isEdit) {
      this.descricao = this.navioEdicao.descricao
      this.data_inicio = this.navioEdicao.data_inicio
      this.data_fim = this.navioEdicao.data_fim
    }
  },
}
</script>
